import { call, put, takeEvery } from 'redux-saga/effects';
import { dpNewsFeedActionCreators, DpNewsFeedActionKeys, FetchDpNewsFeedPosts, IDpNewsFeedPost } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { uiActionCreators } from '../../ui';
import { fetchDpNewsFeedPosts } from '../dpNewsFeedApi';

function* fetchDpNewsFeedPostsSaga(action: FetchDpNewsFeedPosts) {
  yield put(uiActionCreators.showFullPageLoading());
  const response: IApiExecuteRespone<IDpNewsFeedPost[]> = yield call(fetchDpNewsFeedPosts);

  if (!response.requestFailed) {
    yield put(uiActionCreators.hideFullPageLoading());
    if (response.value) {
      yield put(dpNewsFeedActionCreators.setPosts(response.value));
    }
  } else {
    // TODO - show error message
  }
}

export function* watchFetchDpNewsFeedPosts() {
  yield takeEvery(DpNewsFeedActionKeys.FETCH_DP_NEWS_FEED_POSTS, fetchDpNewsFeedPostsSaga);
}
